export default [
  {
    id: 'EmParcelamento',
    colunas: ['Situacao'],
    label: 'Em parcelamento',
    valor: '1, 16',
  },
  {
    id: 'StatusEmAtraso',
    colunas: ['StatusEmParcelamento'],
    label: 'Em atraso',
    valor: '2',
  },
  {
    id: 'StatusSemAtraso',
    colunas: ['StatusEmParcelamento'],
    label: 'Em dia',
    valor: '1',
  },
  {
    id: 'MesPaga',
    colunas: ['MesPaga'],
    label: 'Parcela do mês paga',
    valor: '1',
  },
  {
    id: 'MesNaoPaga',
    colunas: ['MesNaoPaga'],
    label: 'Parcela do mês não paga',
    valor: '2',
  },
  {
    id: 'SemEfeito',
    colunas: ['Situacao'],
    label: 'Sem efeito por solicitação do contribuinte',
    valor: '8',
  },
  {
    id: 'EncerradoPedido',
    colunas: ['Situacao'],
    label: 'Encerrado a pedido do contribuinte',
    valor: '2',
  },
  {
    id: 'EncerradoRescisao',
    colunas: ['Situacao'],
    label: 'Encerrado por rescisão',
    valor: '5',
  },
  {
    id: 'NaoValidado',
    colunas: ['Situacao'],
    label: 'Não validado - primeira parcela não paga',
    valor: '6',
  },
  {
    id: 'EncerradoLiquidacao',
    colunas: ['Situacao'],
    label: 'Encerrado por liquidação',
    valor: '4',
  },
  {
    id: 'AguardandoPrimeiroPagamento',
    colunas: ['Situacao'],
    label: 'Aguardando pagamento da 1ª parcela',
    valor: '7',
  },
  {
    id: 'PossuiObservacao',
    colunas: ['PossuiObservacao'],
    label: 'Possui observação',
    valor: true,
  },
]
